import React from "react";
import styled from "styled-components";

export default styled.input`
    width: 220px !important;
    display: block;
    box-sizing: border-box;
    margin-bottom: 8px;
    height: auto;
    font-size: 16px;
    padding-right: 9px;
    border: none;
    color: #717198;
    
    border: 1px solid lightgrey;
    margin-right: 200px;
    padding: 0 5px;
    margin-top: 4px;
    display: ${(props) => (!props.hidden ? 'block' : 'none')};
`;